module.exports = __webpack_public_path__ + "static/media/expii2.490c234f.jpg";